function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.764,
    height: 79.941,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.338 -1.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.791,
    height: 77.474,
    x: 2.572,
    y: 2.32,
    ry: 3.901,
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#22e0c0",
      strokeWidth: 2.46704,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.505 10.66a.389.389 0 0 1 .39-.39h2.443a.388.388 0 0 1 .39.39V70.3h65c.1 0 .2.039.276.115a.389.389 0 0 1 .115.276v2.443c0 .099-.038.199-.115.275a.388.388 0 0 1-.275.115H45.505Z",
    style: {
      overflow: "hidden",
      fill: "#22e0c0",
      strokeWidth: 0.0765706
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.248 37.467c0-.299.115-.59.337-.82.222-.229.52-.336.819-.336h10.544c.298 0 .59.115.82.337.229.23.336.52.336.819v28.545h-12.856zM86.66 46.916 69.303 31.64 57.748 46.142l-4.74-3.767 15.567-19.487 17.45 15.421 23.5-28.04 4.594 3.867zm-33.653 5.398c0-.299.115-.59.337-.82.222-.229.521-.336.82-.336h10.543c.299 0 .59.115.82.337.23.23.337.52.337.819v13.698H53.008z",
    style: {
      overflow: "hidden",
      fill: "#22e0c0",
      strokeWidth: 0.0765706
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.088 47.62c0-.298.115-.59.337-.82.222-.229.52-.336.82-.336h10.543c.299 0 .59.115.82.337.23.23.336.52.336.82v18.391H69.088Zm16.08 9.77c0-.298.115-.589.337-.819.222-.23.52-.337.82-.337h10.543c.299 0 .59.115.82.337.229.23.336.521.336.82v8.621H85.168Z",
    style: {
      overflow: "hidden",
      fill: "#22e0c0",
      strokeWidth: 0.0765706
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.012,
    cy: 8.378,
    r: 0.052,
    style: {
      overflow: "hidden",
      fill: "green",
      stroke: "#e6597f",
      strokeWidth: 0.0765706
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22e0c0",
    d: "m10.396 64.87 5.685 6.095s2.627 3.08 4.574.003a215.99 215.99 0 0 0 5.55-9.333c5.076-9.12 7.693-11.816 7.693-11.816-2.045-1.192-6.096 1.454-9.226 6.33-1.508 2.35-4.717 7.421-5.85 9.212-.257.405-.576.47-.85.192-.85-.868-2.698-2.773-3.51-3.75-.172-.208-.447-.502-.58-.654-.343-.39-.985-.458-1.46-.133-.265.18-.518.42-.76.645-.549.513-1.117 1.038-1.488 1.527-.392.516-.407 1.116.222 1.682",
    style: {
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPlaceholder);
export default __webpack_public_path__ + "static/media/chart-placeholder.a5dfc5387b1c85c05c8c5f2735638ef6.svg";
export { ForwardRef as ReactComponent };